module.exports = __webpack_public_path__ + "static/media/storeVNActive.04b34e68.png";